import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    className?: string
}

const DataTableLoader: React.FC<Props> = ({ className = '' }) => {
    const { t } = useTranslation()
    return (
        <div className="flex justify-center items-center h-full">
            <div className={'animate-spin h-12 w-12 border-4 border-blue-500 border-t-transparent rounded-full ' + className}></div>
            <span className="ml-3 text-gray-700 font-medium">{t('Loading data ...')}</span>
        </div>
    )
}

export default DataTableLoader
